import makeClass from 'clsx';
import { dsThemeContextManager } from './context';

/**
 * getTheme utility to support to provide object containing currentTheme and currentColorScheme.
 *
 * @param props - see typescript definition
 * @param context - see typescript definition
 * @param styles - The css modules styles for the component
 */
export var getTheme = function getTheme(props, context, fallbackContext) {
  var styles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var currentTheme = props.theme || context.theme || (fallbackContext === null || fallbackContext === void 0 ? void 0 : fallbackContext.theme) || dsThemeContextManager.getCurrentTheme() || 'intuit';

  // This is in place for legacy code that uses a "default" theme
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (currentTheme === 'default') {
    currentTheme = 'intuit';
  }
  var currentColorScheme = props.colorScheme || context.colorScheme || (fallbackContext === null || fallbackContext === void 0 ? void 0 : fallbackContext.colorScheme) || 'light';
  var themeClass = makeClass(styles[currentTheme], styles[currentColorScheme]);
  return {
    currentTheme: currentTheme,
    currentColorScheme: currentColorScheme,
    themeClass: themeClass,
    setColorScheme: context.setColorScheme,
    setTheme: context.setTheme
  };
};
//# sourceMappingURL=utils.js.map